import React, { useState } from 'react';
import './index.scss'
import { RightOutlined } from '@ant-design/icons'

function Questions() {

  const [activeIndex, setActiveIndex] = useState(0)
  const list = [
    {
      title: '开店管理',
      questions: [
        {
          title: '我想要开笨鸟小店，怎么做？',
          content: (
            <span>
          通过登录笨鸟官网（<a href='https://benscm.com/' target='_blank'>https://benscm.com/</a>)，点击入驻流程--0元开店，输入对应开店信息即可开店
        </span>
          )
        },
        {
          title: '一个营业执照/一个身份证可以开几个店铺？',
          content: '一个营业执照可以开多个店铺，新机和配件需要两个店铺，独立运营'
        },
        {
          title: '开店过程中信息采集审核是多久？',
          content: '收到资料后， 1-3个工作日内，我们将通过邮件短信通知开店是否成功'
        },
        {
          title: '开店需要什么材料？ ',
          content: '目前只支持以法人身份开店，需要提供营业执照证书、以及法人身份证正反面、联系电话、店铺位置、店铺门头照片'
        },
        {
          title: '开店涉及哪些费用？',
          content: '目前开店只需要提供相应资质，0元开店'
        },
        {
          title: '平台入驻协议',
          content: '笨鸟平台入驻协议，用户供应商与平台之间入驻，交易，资金结算，以及商务问题的基本协议，在店铺入驻后是必须签署的基本协议，可通过商务协议管理查看'
        },
        {
          title: '资金结算协议',
          content: '商户和平台的结算是通过商品定价方式，抽取中间佣金方式结算，我们将通过三方平台按周期与供应商结算'
        },
        {
          title: '商品质量保证倡议书',
          content: '商品质量保证倡议书'
        },
      ]
    },
    {
      title: '账号管理',
      questions: [
        {
          title: '我的账号密码是什么？',
          content: '开店成功后，我们将邮件或短信通知注册手机号，账号为注册的手机号，密码为注册店铺时的密码，可进入商户管理中心修改密码'
        },
        {
          title: '财务信息管理',
          content: '开店成功后，根据店铺注册信息自动在平台开户，修改注册信息需要平台审批，提现需要绑定银行卡'
        }
      ]
    },
    {
      title: '商品管理 ',
      questions: [
        {
          title: '商品信息管理',
          content: '通过门户商品中心管理，根据平台要求提供商品名称、销售库存、商品主图，商品价格，商品配送方式，商品详情即可完成商品的创建'
        },
        {
          title: '商品如何上架？',
          content: '商品维护好对应的信息后，通过列表点击商品上架，商品上架需通过平台审批完成后即可在平台中上架售卖'
        },
        {
          title: '我不想卖了（缺货了）怎么下架商品？',
          content: '商品如果缺货，可通过维护销售库存，前端提示商品库存不足无法下单，如果因为供给缺货问题，可在列表直接下架商品'
        }
      ]
    },
    {
      title: '订单管理',
      questions: [
        {
          title: '订单下单管理',
          content: (
            <span>
              订单下单后，首页有消息提醒来单提示，并在订单管理列表中优先排序展示。<br />
            订单取消后，需要商户审批，即可完成订单取消，订单履约完成后只能退货'
            </span>
          )
        },
        {
          title: '订单核销码管理',
          content: (
            <span>
              用户上门提取商品时，需要展示核销码，通过订单管理列表核销，核销操作成功表示交易完成。<br />
            商品为配送时，通过订单填写物流信息，物流签收后，视为订单交易成'
            </span>
          )
        },
        {
          title: '订单支付管理',
          content: '订单支付为线上支付，支付统一到平台，通过后期与供应商对账结算'
        },
        {
          title: '订单退货管理',
          content: '用户发起退货，商务需要审批订单，确认商品退货后，平台退款用户'
        },
      ]
    },
    {
      title: '资金管理',
      questions: [
        {
          title: '结算周期内如何进行账单对账？',
          content: '订单核销完成后自动进入结算流程，平台将自动完成与订单的对账，可在订单结算页面查看'
        },
        {
          title: '对公账户还是对私账户？',
          content: '需商家提供对公账户'
        },
        {
          title: '如何进行资金结算？',
          content: '目前依托于三方资金机构进行结算，结算周期为一周'
        },
        {
          title: '是否需要开具发票？',
          content: (
            <span>
              销售订单交易，用户若发起发票请求，商铺需要开取正式发票 <br />
              订单交易信息服务费，平台提供发票开取申请
            </span>
          )
        },
      ]
    },
  ]


  return (
    <>
      <div className="questions-container">
        <div className="question-menu">
          <div className="menu-title">常见问题</div>
          <div className="menu-list">
            {
              list.map((item, index) => (
                <div className={`menu-item ${activeIndex == index ? 'active' : ''}`} key={index} onClick={() => setActiveIndex(index)}>
                  <span className='text'>{item.title}</span>
                  <RightOutlined />
                </div>
              ))
            }
          </div>
        </div>
        <div className="question-content">
          <div className='content-list'>
            {
              list[activeIndex].questions.map((item, index) => {
                return (
                  <div className="content-item">
                    <div className="item-title">
                      {index + 1}、{item.title}
                    </div>
                    <div className="item-description">{item.content}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default Questions;
